import { root } from "postcss";

export default {
  state: {
    systemLanguage: "english"
  },

  getters: {
    getSystemLanguage(state) {
      return state.systemLanguage;
    },

    getDirectionStatus(state) {
      return state.systemLanguage != "english" ? "rtl" : "ltr";
    }
  },

  mutations: {
    setSystemLanguage(state, payload) {
      state.systemLanguage = payload;
    }
  },

  actions: {
    async setSystemLanguage({ commit, rootGetters }, payload) {
      if (rootGetters.user != null) {
        commit("setSystemLanguage", payload);
        rootGetters.user.set("language", payload);
        await rootGetters.user.save();
      }
    }
  }
};
